module.exports = __webpack_public_path__ + "img/3.f401a617.png";